import {
  isServer,
  MutationCache,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query";
import { handleServerError } from "../error-handler-server";
import { captureError } from "../error-handler";

function makeQueryClient(isServerEnv: boolean) {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        console.error("Error in query:", error);
        if (isServerEnv) {
          handleServerError(error);
        } else {
          // Show global toast unless explicitly disabled via meta
          const showToast = query.options.meta?.errorToast !== false;
          captureError(error, { showToast });
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        console.error("Error in mutation:", error);
        if (isServerEnv) {
          handleServerError(error);
        } else {
          // Show global toast unless explicitly disabled via meta
          const showToast = mutation.options.meta?.errorToast !== false;
          captureError(error, { showToast });
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 10 * 60 * 1000,
      },
    },
  });
}

//refer - https://tanstack.com/query/latest/docs/framework/react/guides/advanced-ssr
let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    // Server: always make a new query donor
    return makeQueryClient(true);
  } else {
    // Browser: make a new query donor if we don't already have one
    // This is very important, so we don't re-make a new donor if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query donor
    if (!browserQueryClient) browserQueryClient = makeQueryClient(false);
    return browserQueryClient;
  }
}
